import React, { useEffect, useState, useRef, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import MicroModal from "micromodal";
import moment from "moment";
import { sub, format } from "date-fns";
import MicRecorder from "mic-recorder-to-mp3";

import {
  addChat,
  addChatSimult,
  typingadd,
  clearConferenceExt,
  CallConsultaInterna,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  CloseMonitoring,
  InsertUploadMonitoring,
  RespostasRapidasida,
  DetailsAnotationsida,
  GetInteractionsModal,
  InteracoesContactNumber,
  SearchingHistoryData,
  DetailsMarkstarida,
  DetailsFileShared,
  changeSelectedChatMonitoring,
} from "../../../actions";
import { InitialMonitoring, SharedScreen } from "../../../actions/websocket";
import unicodeToChar from "../../../actions/formatUnicode";

import Typography from "../../Typography";
import TransferClientModalEquipes from "../../../containers/TransferClientModalEquipes";
import AddAnotationModal from "../NewModals/AddAnotationModal/AddAnotationModal";

import { connection_platform } from "../../../services/api";
import "../modals.css";
import "./modalsV2.css";

import { ReactComponent as WhatsappIcon } from "../../../build/images/icons-channels/whatsapp-large.svg";
import { ReactComponent as FacebookIcon } from "../../../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../../../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../../../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../../../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as SMSICON } from "../../../build/images/sms-new.svg";
import { ReactComponent as TWITTERICON } from "../../../build/images/twitter-new.svg";
import { ReactComponent as TEAMS } from "../../../build/images/channelsNew/teamsBig.svg";
import { ReactComponent as WhatsappVozIcon } from "../../../build/images/whatsapp_voice.svg";

import HeaderContactInfos from "./HeaderContactInfos/HeaderContactInfos";
import SideQueues from "./SideQueues/SideQueues";
import SideDetails from "../../SideDetails/SideDetails";
import MessageContainer from "./MessageContainer";

let gethostname = window.location.hostname;
let pathname = "";

let iplocal = connection_platform.ip_intern;
let port = connection_platform.port_backend_intern;
port = localStorage.getItem("port");

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

let ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const { meses } = require("../../../services/data");
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const MonitoringDashboardV2 = ({
  isOpen,
  openClick,
  onClose,
  attendant = { label: "Atendente Teste" },
  infoJson,
}) => {
  const usersReduce = useSelector((state) => state.agents);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const Monitoring = useSelector((state) => state.monitoring);
  const ClientUserMonitors = useSelector((state) => state.clientusermonitors);
  const Messages = useSelector((state) => state.messages);
  const History = useSelector((state) => state.history);
  const dispatch = useDispatch();

  const selectedChat = useSelector((state) => state.selectedChatMonitoring);
  const setSelectedChat = (payload) => {
    dispatch(changeSelectedChatMonitoring(payload));
  };
  // const [selectedChat, setSelectedChat] = useState(null);
  const [arrayChats, setArrayChats] = useState([]);
  const [typeMonitoring, setTypeMonitoring] = useState(1);
  const [monitorMessage, setMonitorMessage] = useState([]);
  const [transferInfo, setTransferInfo] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [detailsOptions, setDetailsOptions] = useState({
    interactions: false,
    notes: false,
    favMsg: false,
    shareArchives: false,
  });
  const [historyInfo, setHistoryInfo] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchWord, setSearchWord] = useState({ atual: 0, total: 0 });
  const [hasVoice, setHasVoice] = useState(false);
  const [saveAttendant, setSaveAttendant] = useState("");

  const infoJsonUpdated = useMemo(() => {
    let newInfoJsonUpdated = infoJson;
    try {
      if (Array.isArray(usersReduce)) {
        const userMonitored = usersReduce.find(
          (client) => parseInt(Monitoring.userout) === parseInt(client.iduser),
        );
        if (Boolean(userMonitored)) {
          newInfoJsonUpdated = userMonitored.jsoncall;
        }
      }
    } catch (error) {
      console.log("infoJsonUpdated Error: ", error);
    }
    return newInfoJsonUpdated;
  }, [infoJson, usersReduce]);

  const timeoutScrollToFirstSerachedTerm = useRef(null);
  const carouselRef = useRef(null);
  let closeRef = useRef();
  let auxdia = "";
  let dia = "";
  // let searchText = "";
  let valorInput = "";
  // let arrowterm = 0;
  // Array com informações de cada chat (nome, id, e algum identificador de rede social)

  function makeid(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  const getMediaIcon = (mediaId) => {
    switch (parseInt(mediaId)) {
      case 1:
        return <VozIcon />;
      case 2:
        return <WebchatIcon />;
      case 3:
        return <EmailIcon />;
      case 4:
        return <FacebookIcon />;
      case 5:
        return <WhatsappIcon />;
      case 6:
        return <InstaIcon />;
      case 8:
        return <TelegramIcon />;
      case 9:
        return <TWITTERICON />;
      case 11:
        return <GOOGLEGBM />;
      case 12:
        return <SMSICON />;
      case 15:
        return <TEAMS />;
      case 16:
        return <WhatsappVozIcon />;
      default:
        break;
    }
  };

  const closeModal = (modal) => {
    closeMonitoringIn(MonitoringSimult[0], Monitoring, MonitoringSimult);
    setTypeMonitoring(1);
    setHasVoice(false);
    setArrayChats([]);
    setSelectedChat(null);
    setMonitorMessage([]);
    setSaveAttendant("");
    setOpenDetails(false);
    setDetailsOptions({
      interactions: false,
      notes: false,
      favMsg: false,
      shareArchives: false,
    });
    setOpenSearch(false);
    onClose();
  };

  function tratarUnderline(valor) {
    valor = valor.split(" ");
    const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let valorFim = [];
    for (let variavel of valor) {
      if (!expresionRegular.test(variavel)) {
        variavel = variavel
          .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
          .replaceAll("\n", "</br>")
          .replaceAll('"}', "")
          .replaceAll("\\n", "</br>")
          .replaceAll("\n", "</br>")
          .replaceAll("\\r", "")
          .replaceAll("\r", "");
      }
      valorFim.push(unicodeToChar(variavel));
    }
    return valorFim
      .join(" ")
      .replace(/(^|\s)_([^_]+?)_(?=\s|$)/g, "$1<em>$2</em>");
  }

  const closeMonitoringIn = (simult, monitoring, monitoringsimult) => {
    if (monitoringsimult.length > 0) {
      dispatch(CloseMonitoring(simult, monitoringsimult));
    }
  };

  const InitialMonitoringAction = (
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
  ) => {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (parseInt(auxline) !== parseInt(line)) {
          editTypeMonitoring(userout, line, userin, ramal);
        }
      } else {
        reduxMonitoringInitial(userin, userout, name, line, ramal);
      }
    } else {
      reduxMonitoringInitial(userin, userout, name, line, ramal);
    }
  };

  const reduxMonitoringInitial = (userin, userout, name, line, ramal) => {
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const editTypeMonitoring = (userout, line, userin, ramal) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const InitialCall = (chatsimult, user) => {
    let erro = 0;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          true,
        );
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          false,
        );
      }
    } else {
      reduxCallInitial(
        parseInt(user.iduser),
        user.label,
        user.ramal,
        user,
        false,
      );
    }
  };

  const reduxCallInitial = (iduser, label, ramal, user, isConference) => {
    if (isConference) {
      dispatch(clearConferenceExt());
      dispatch(CallConsultaInterna(ramal, iduser, user));
    } else {
      reduxChatInitial(iduser, label, true, false, ramal);
      dispatch(CallConsultaInterna(ramal, iduser, user));
    }
    document.getElementById("simulation_click").click();
  };

  const reduxChatInitial = (iduser, displayname, active, opencall, ramal) => {
    let datatime = moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, opencall, ramal, datatime),
    );
    dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    document.getElementById("simulation_click").click();
  };

  const changeDisplayTransfer = (e, cdrid, serverid, usermon, number) => {
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
    localStorage.setItem("telcliente", number);
    MicroModal.show("modal__transferir__chamada__equipes");
  };

  const handleSelectCall = (callSelected, search) => {
    setSelectedChat(callSelected);

    if (!!search) {
      setOpenSearch(true);
      getTermText({ target: { value: search } }, true);

      return;
    }
    setOpenSearch(false);
    setSearchText("");
  };

  const buttonSearchAnotation = (e, telefone) => {
    e.preventDefault();

    let erro = 0;
    const datainit = format(
      sub(new Date(), {
        months: 1,
      }),
      "yyyy-MM-dd",
    );
    const datafim = format(new Date(), "yyyy-MM-dd");
    const idcriticidade = "";

    let comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone),
      );
    }
  };

  const ViewAnotations = (e, telefone, cliente, cdrid) => {
    MicroModal.show("modal__anotacoes-adicionar");
    buttonSearchAnotation(e, telefone);
    dispatch(GetInteractionsModal(cliente, telefone, cdrid));
  };

  const DisplayHistoric = (e, telefone, cdrid) => {
    e.preventDefault();
    const agora = moment().subtract(7, "days");
    let datainit = agora.format("YYYY-MM-DDT00:00");
    let datafim = moment().format("YYYY-MM-DDT23:59");
    let today = moment().format("YYYY-MM-DD");
    let idgroup = InfoUsers.idgroup;

    SearchHistory(e, telefone, cdrid, datainit, datafim);
    dispatch(
      InteracoesContactNumber(
        telefone.substr(2),
        datainit,
        datafim,
        "",
        idgroup,
      ),
    );
  };

  const SearchHistory = (e, telefone, cdrid, datainit, datafim) => {
    let histstart = datainit;
    let histend = datafim;
    let idgroup = InfoUsers.idgroup;
    dispatch(
      SearchingHistoryData(histstart, histend, cdrid, telefone, idgroup),
    );
  };

  const buttonSearchMarkstar = (e, telefone) => {
    e.preventDefault();
    let erro = 0;

    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");

    const comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    }
  };

  const buttonSearchFileCompart = (e, telefone) => {
    e.preventDefault();
    let erro = 0;
    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

    const comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (formats == "") erro = 1;

    if (midias == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
    }
  };

  const ShowModals = (e, modal, telefone, cdrid, contactName) => {
    //Função que seta o nome e o número do contato pros modais
    dispatch(GetInteractionsModal(contactName, telefone));
    //
    switch (modal) {
      case "modal__anotacoes-details":
        MicroModal.show("modal__anotacoes-details-new");
        // buttonSearchAnotation(e, telefone);
        break;
      case "modal__arquivos-compartilhados-details":
        MicroModal.show("modal__arquivos-compartilhados-details");
        // buttonSearchFileCompart(e, telefone);
        break;
      case "modal__mensagens-favoritas-details":
        MicroModal.show("modal__mensagens-favoritas-details");
        // buttonSearchMarkstar(e, telefone);
        break;
      case "modal__historico-atendimento-details":
        MicroModal.show("modal__historico-atendimento-details");
        SearchHistory(e, telefone, cdrid);
        break;
      case "modal__agenda-pf__cliente__interacoes_history":
        MicroModal.show("modal__historico-atendimento-details");
        // DisplayHistoric(e, telefone, cdrid);
        break;
      default:
        break;
    }
  };

  const scrollToFirstSerachedTerm = (
    direction,
    elems,
    total,
    currentInitial,
  ) => {
    let current = currentInitial;

    if (total === 0) return;

    if (direction === "less") {
      current = (current - 1 + total) % total;
    } else if (direction === "more") {
      current = current % total;
    }
    setSearchWord({ atual: current, total });
    elems[current].scrollIntoView({ block: "center", behavior: "smooth" });
  };

  const getTermText = (event, isToScroll = false) => {
    setSearchText(event.target.value);

    setTimeout(() => {
      const elems = document.getElementsByTagName("mark");
      const tam = elems.length;
      let expandLess = 0;

      setSearchWord({ total: tam, atual: expandLess });
      if (isToScroll) {
        if (
          timeoutScrollToFirstSerachedTerm &&
          timeoutScrollToFirstSerachedTerm.current
        ) {
          clearTimeout(timeoutScrollToFirstSerachedTerm.current);
        }
        timeoutScrollToFirstSerachedTerm.current = setTimeout(() => {
          scrollToFirstSerachedTerm("more", elems, tam, expandLess);
        }, 40);
        // scrollToFirstSerachedTerm("more", elems, tam, expandLess);
      }
    }, 100);
  };

  const getVoiceChannel = (todos) => {
    let aux = todos ? todos.split("¿") : [];
    if (aux.length > 0) {
      let voiceCall = aux.filter((todo) => {
        return todo.split("§")[0] === "1" || todo.split("§")[0] === "16";
      });

      if (voiceCall.length > 0) {
        setHasVoice({
          cliente: voiceCall[0].split("§")[1],
          idatendimento: "voice",
          idmidia: voiceCall[0].split("§")[0],
          datatimeatd: format(new Date(), "dd/MM/yyyy HH:mm:ss"),
          telefone: voiceCall[0].split("§")[1],
        });
      } else {
        setHasVoice(false);
      }
    } else {
      setHasVoice(false);
    }
  };

  useEffect(() => {
    if (attendant.iduser) {
      MicroModal.show("modal__monitoring-dashboard");
      setSaveAttendant(attendant);
      setTypeMonitoring(parseInt(attendant.monitoringLine));
      dispatch(RespostasRapidasida(InfoUsers.id));
    }
  }, [attendant]);

  useEffect(() => {
    getVoiceChannel(infoJsonUpdated);
  }, [infoJsonUpdated]);

  useEffect(() => {
    if (selectedChat) {
      const messages = Messages[selectedChat.idatendimento];
      setMonitorMessage(messages && messages.length > 0 ? messages : []);
    } else {
      setMonitorMessage([]);
    }
  }, [Messages, selectedChat]);

  useEffect(() => {
    const filterClients = ClientUserMonitors.filter(
      (client) => parseInt(Monitoring.userout) === parseInt(client.monuser),
    );
    setArrayChats([...filterClients]);

    if (
      attendant &&
      parseInt(attendant.monitoringLine) > 1 &&
      filterClients.length > 0
    ) {
      setSelectedChat(filterClients[0]);
    }

    if (filterClients.length === 0 && selectedChat && !hasVoice) {
      closeModal("modal__monitoring-dashboard");
    }
  }, [ClientUserMonitors]);

  useEffect(() => {
    if (blobURL && isRecording === true) {
      let data = new FormData();
      let hora = moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let namefile = random + ".mp3";
      data.append("file", blobURL, namefile);
      const AudioFile = data;

      dispatch(
        InsertUploadMonitoring(
          AudioFile,
          InfoUsers,
          selectedChat,
          "",
          makeid(32),
          blobURL.size,
          Monitoring.line,
        ),
      );
      setBlobURL("");
    }
  }, [blobURL, isRecording]);

  useEffect(() => {
    let history = [...History];
    let historyRecent = [...History];
    let totalhistory = 0;

    if (History.lenght !== 0) {
      historyRecent = historyRecent.filter((history) =>
        [1].includes(history.mimetypeid),
      );
      if (historyRecent.lenght === 0) {
        historyRecent = [];
      }
      if (history[0] != undefined) {
        totalhistory = history[0].interacoes;
      }
    } else {
      history = [];
      historyRecent = [];
    }

    setHistoryInfo({ history, historyRecent, totalhistory });
  }, [History]);

  useEffect(() => {
    if (!hasVoice && selectedChat && selectedChat.idatendimento === "voice") {
      if (arrayChats.length > 0) {
        setSelectedChat(arrayChats[0]);
      } else {
        closeModal("modal__monitoring-dashboard");
      }
    }
  }, [hasVoice]);

  useEffect(() => {
    if (MonitoringSimult.length === 0) {
      MicroModal.close("modal__monitoring-dashboard");
    }
  }, [MonitoringSimult]);

  console.log("ARRAYCHATS É", ClientUserMonitors, arrayChats);

  return (
    <div className="monitoring-dashboard-v2-container">
      <div
        className="modal micromodal-slide"
        id="modal__monitoring-dashboard"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1" style={{ zIndex: 2 }}>
          <div
            className="modal__container monitoring-dashboard__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="monitoring-dashboard__container"
          >
            <div className="monitoring-dashboard  monitoring-dashboard-v2">
              <header className="dashboard-header">
                <Typography.H2 color={"blue-selected-4"} weight={700}>
                  Monitoria
                </Typography.H2>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal("modal__monitoring-dashboard");
                  }}
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                  ref={closeRef}
                ></button>
              </header>

              <main>
                <div className={`container`}>
                  <HeaderContactInfos
                    attendant={attendant}
                    typeMonitoring={typeMonitoring}
                    setTypeMonitoring={setTypeMonitoring}
                    hasVoice={hasVoice}
                    InitialCall={InitialCall}
                    InitialMonitoringAction={InitialMonitoringAction}
                    selectedChat={selectedChat}
                    setSelectedChat={setSelectedChat}
                  />
                  <div className="monitoring-dashboard-v2__main-content">
                    <SideQueues
                      arrayChats={arrayChats}
                      selectedChat={selectedChat}
                      setSelectedChat={setSelectedChat}
                      setMonitorMessage={setMonitorMessage}
                      changeDisplayTransfer={changeDisplayTransfer}
                      ViewAnotations={ViewAnotations}
                      setOpenSearch={setOpenSearch}
                      hasVoice={hasVoice}
                      onSelectCall={handleSelectCall}
                    />
                    <MessageContainer
                      selectedChat={selectedChat}
                      setSelectedChat={setSelectedChat}
                      setMonitorMessage={setMonitorMessage}
                      changeDisplayTransfer={changeDisplayTransfer}
                      ViewAnotations={ViewAnotations}
                      setOpenSearch={setOpenSearch}
                      openDetails={openDetails}
                      setOpenDetails={setOpenDetails}
                      openSearch={openSearch}
                      getTermText={getTermText}
                      searchText={searchText}
                      searchWord={searchWord}
                      setSearchText={setSearchText}
                      setSearchWord={setSearchWord}
                      monitorMessage={monitorMessage}
                      hasVoice={hasVoice}
                      typeMonitoring={typeMonitoring}
                      setIsRecording={setIsRecording}
                      Mp3Recorder={Mp3Recorder}
                      setBlobURL={setBlobURL}
                    />
                    {Boolean(selectedChat) &&
                      selectedChat.idatendimento !== "voice" && (
                        <SideDetails
                          selectedChat={selectedChat}
                          openDetails={openDetails}
                          setOpenDetails={setOpenDetails}
                          detailsOptions={detailsOptions}
                          setDetailsOptions={setDetailsOptions}
                          DisplayHistoric={DisplayHistoric}
                          historyInfo={historyInfo}
                          ShowModals={ShowModals}
                          tratarUnderline={tratarUnderline}
                          getMediaIcon={getMediaIcon}
                          buttonSearchAnotation={buttonSearchAnotation}
                          buttonSearchMarkstar={buttonSearchMarkstar}
                          buttonSearchFileCompart={buttonSearchFileCompart}
                        />
                      )}
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>

      <TransferClientModalEquipes
        dashboardMonitor={true}
        setMonitorDash={setTransferInfo}
      />

      <AddAnotationModal selectedChat={selectedChat} />
    </div>
  );
};

export default MonitoringDashboardV2;
